export default {
  appointmentContainer: {
    title: 'Danni immobiliari',
    solution: 'Soluzione:',
    text: 'Scegli un professionista autorizzato da Allianz',
    text2: 'Data desiderata per i lavori',
    text3: 'Orario di passaggio desiderato:',
    infoBox: 'Se gli slot non sono disponibili o incompatibili con le tue disponibilità, scegli di essere richiamato per fissare l\'appuntamento entro 48 ore*.',
    workHour: '*Orari lavorativi e salvo problemi eccezionali o indipendenti dalla nostra volontà',
    actions: {
      primary: 'Confermare il tempo',
      secondaryHelpText: 'Nessuno di questi slot è conveniente per te?',
      secondary: 'Essere richiamato per fissare un appuntamento',
      ren: {
        primary: 'Conferma la fascia oraria',
        tertiary: 'Scegli un’altra soluzione'
      }
    },
    dates: {
      months: {
        january: 'Gennaio',
        february: 'Febbraio',
        march: 'Marzo',
        april: 'Aprile',
        may: 'Maggio',
        june: 'Giugno',
        july: 'Luglio',
        august: 'Agosto',
        september: 'Settembre',
        october: 'Ottobre',
        november: 'Novembre',
        december: 'Dicembre'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Errore! Non è stato possibile recuperare i giorni disponibili per l’appuntamento.',
        postAppointment: 'Errore! L’appuntamento selezionato non può essere programmato.',
        postContact: 'Errore! Il contatto non può essere richiesto.'
      }
    }
  }
}
